export const categories = [
  {
    slug: 'features',
    name: '功能介绍',
    description: '全面了解91c平台的核心功能与特色亮点，助您快速上手使用。',
    icon: 'ri-function-line',
    count: 12,
  },
  {
    slug: 'tutorials',
    name: '使用教程',
    description: '详细的91c操作指南，从入门到精通，覆盖每个使用场景。',
    icon: 'ri-book-open-line',
    count: 18,
  },
  {
    slug: 'reviews',
    name: '用户评价',
    description: '真实用户的使用体验与反馈，了解91c在实际场景中的表现。',
    icon: 'ri-star-line',
    count: 24,
  },
  {
    slug: 'versions',
    name: '最新版本',
    description: '91c各版本更新日志与新功能一览，紧跟平台发展动态。',
    icon: 'ri-download-cloud-line',
    count: 8,
  },
  {
    slug: 'faq',
    name: '常见问题',
    description: '关于91c的常见疑问解答，帮您快速解决使用中遇到的问题。',
    icon: 'ri-question-line',
    count: 15,
  },
];

export const categoryMap: Record<string, string> = {
  features: '功能介绍',
  tutorials: '使用教程',
  reviews: '用户评价',
  versions: '最新版本',
  faq: '常见问题',
};